import { GrapevinePostCreationApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { DEFAULT_CACHING } from '@/configs/query';
import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';
import { useAuth } from '@/features/authorization/provider/useAuth';
import type {
  PostCreationContext,
  PostCreationOptions
} from '@/features/post-editor/types/postCreationOptions';

export const useGetPostCreationOptions = (
  context: PostCreationContext,
  enabled = true
) => {
  const { isAuthenticated } = useAuth();
  const configuration = useApiConfiguration();
  const api = useMemo(
    () => new GrapevinePostCreationApi(configuration),
    [configuration]
  );

  return useQuery({
    // Configuration is transport/auth scoped; the response itself is language-neutral.
    queryKey: [API_CACHE_KEYS.POST_CREATION_OPTIONS, context, configuration],
    enabled: isAuthenticated && enabled,
    queryFn: async (): Promise<PostCreationOptions> =>
      (await api.getOptions({
        creationContext: context
      })) as PostCreationOptions,
    ...DEFAULT_CACHING
  });
};
